<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="img-box page-banner">
            <img src="/assets/manufacture/engine/tianjin/tj.jpg" alt=""></img>
            <div class="title-box">
                <div class="manufacture-t1">
                    变速器天津工厂
                </div>
                <div class="manufacture-t2">
                    作为第三个发动机生产工厂，位于天津市滨海新区，涉及缸体、下缸体、缸盖、曲轴、装配、冷（热）试6类生产线；<br />
                    产品规划2种平台（ EG1.5T汽油机、EB1.5T汽油机）、13种量产机型（已停产8款、量产中5款）。
                </div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                机加车间
            </div>
            <div class="page-t2">
                共有8条线体，主要由日系、德系设备组成，平均自动化率70%
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">

                        <div class="text-box ">
                            <div class="title">
                                核心工艺（随动磨削工艺）
                            </div>
                            <div class="destils">
                                采用高精度、多轴随动磨削曲轴径（定位精度0.0001mm），可实现主轴颈、连杆颈同步磨削，效率大幅提升<br />
                                自主开发安东系统、返线防错系统等信息化防错，关键防错采用Artis监控、马波斯在线测量技术
                            </div>
                        </div>
                        <div class="img-box">
                            <img src="/assets/manufacture/engine/tianjin/tj1-1.jpg" alt="">
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                装试车间
            </div>
            <div class="page-t2">
                共2条线体，平均自动化率30%
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img src="/assets/manufacture/engine/tianjin/tj2-1.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                核心工艺
                            </div>
                            <div class="destils">
                                冷试工艺、智能相机全方位检测工艺及试漏工艺（采用法国阿黛凯、德国孚罗里西高精度试漏仪），工业机器人自动拧紧、涂胶等<br />
                                防错技术：多点位机械视觉、工装+光电、特殊功能传感器（颜色、位移、激光、距离）、AI视觉防错应用系统（手部动态识别）等

                            </div>
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: '变速器天津工厂 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'manufacture/en/tianjin.html'
};

import { createApp } from 'vue';
import App from './tianjin.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./tianjin.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
